export default {"src":"/_next/static/media/clock.2447e623.svg","height":12,"width":12};